import { AppConstants } from '../app.constants';

/** Language codes the app ships translations for. */
type AppLanguage =
  (typeof AppConstants.LANGUAGES)[keyof typeof AppConstants.LANGUAGES];

/** One URL per app language, for external pages published in each of them. */
export type LocalizedLinks = Record<AppLanguage, string>;

function hasLinkFor(
  links: LocalizedLinks,
  language: unknown,
): language is AppLanguage {
  return (
    typeof language === 'string' &&
    Object.prototype.hasOwnProperty.call(links, language)
  );
}

/**
 * Picks the version of an external page that matches the app language.
 *
 * @param links - The page URL for each app language.
 * @param language - The current app language code, such as `ptBR` or `en`.
 * @returns The URL for `language`.
 *
 * @remarks Unknown or missing languages fall back to `ptBR`, the project-wide
 * default language.
 */
export function resolveLocalizedLink(
  links: LocalizedLinks,
  language: string | null | undefined,
): string {
  if (hasLinkFor(links, language)) {
    return links[language];
  }
  return links[AppConstants.LANGUAGES.PT_BR];
}
